module.exports = __webpack_public_path__ + "assets/log-white.a40e62ad.svg";